(() => {
  const root = window.Shopify?.routes?.root || '/';
  const drinkKey = 'pm:drink-suggestion:dismissed';
  function hideDismissed() {
    try { if (sessionStorage.getItem(drinkKey)) document.querySelectorAll('[data-pm-drink-suggestion]').forEach(e => e.hidden = true); } catch (_) {}
  }
  hideDismissed();
  document.addEventListener('shopify:section:load', hideDismissed);
  document.addEventListener('click', event => {
    const dismiss = event.target.closest('[data-pm-drink-dismiss]');
    if (!dismiss) return;
    dismiss.closest('[data-pm-drink-suggestion]').hidden = true;
    try { sessionStorage.setItem(drinkKey, '1'); } catch (_) {}
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-pm-drink-form]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button');
    if (button.disabled) return;
    button.disabled = true;
    const status = form.querySelector('[data-pm-drink-status]');
    status.textContent = 'Adding your Cooler…';
    try {
      const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: {Accept: 'application/json'}, body: new FormData(form) });
      const data = await response.json();
      if (!response.ok) throw Error(data.description || 'This drink could not be added. Please try again.');
      status.textContent = 'Added! Updating your basket…';
      location.reload();
    } catch (error) { status.textContent = window.PurefectOrderSupport.format(error.message); button.disabled = false; }
  });
  // Refresh eligibility after another cart control changes quantities or contents.
  let updating = false;
  async function refreshSuggestion() {
    if (updating || !document.querySelector('[data-pm-drink-slot]')) return;
    updating = true;
    try {
      const response = await fetch(root + 'cart?section_id=purefect-cart-impulse');
      if (!response.ok) return;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = doc.querySelector('[data-pm-drink-slot]');
      const old = document.querySelector('[data-pm-drink-slot]');
      if (old && next) old.replaceWith(next);
      hideDismissed();
    } catch (_) {} finally { updating = false; }
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, refreshSuggestion);
  document.addEventListener('pm:hub:change', event => {
    const info = event.detail;
    document.querySelectorAll('[data-pm-combined-date]').forEach(el => { el.textContent = info?.chooseAtCheckout ? 'Choose location at checkout' : info?.nextDelivery?.label || 'View pickup dates'; });
  });
})();
